import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastService } from './toasts.service';
import { catchError, map, Observable, of } from 'rxjs';
import { NotificationDTO, NotificationResults } from '../models/notifications';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
/*
Will just be for fetching notifications, and marking them as seen etc
Notification creation will rather be done from EventService, FeedbackService in API
*/
export class NotificationsService {
  private apiUrl = `${environment.apiUrl}/notifications`;
  private authorized: boolean = false;

  constructor(private http: HttpClient, private authService: AuthService, private toastService: ToastService) {
    this.authService.authorized.subscribe(authorized => this.authorized = authorized);
  }

  /** Get user notifications */
  getNotifications(
    page = 1,
    pageSize = 20,
    onlyUnseen = true
  ): Observable<NotificationResults> {
    if(!this.authorized)
    {
      return of({
        notifications: [],
        totalCount: 0,
        unseenCount: 0,
        currentPage: 0,
        totalPages: 0,
        pageSize: 0
      });
    }
    return this.http
      .get<NotificationResults>(
        `${this.apiUrl}?page=${page}&pageSize=${pageSize}&onlyUnseen=${onlyUnseen}`,
        { withCredentials: true }
      )
      .pipe(
        catchError(() => {
          this.toastService.show('Failed to fetch notifications', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of({
            notifications: [],
            totalCount: 0,
            unseenCount: 0,
            currentPage: page,
            totalPages: 0,
            pageSize,
          });
        })
      );
  }

  /** Mark a notification as seen */
  markAsSeen(notificationId: string): Observable<boolean> {
    return this.http
      .patch(
        `${this.apiUrl}/${notificationId}/seen`,
        {},
        {
          withCredentials: true,
          headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        }
      )
      .pipe(
        map(() => true),
        catchError(() => {
          this.toastService.show('Failed to mark notification as seen', {
            classname: 'bg-danger text-light p-3 fs-5',
          });
          return of(false);
        })
      );
  }
}
